/**
 * authService.js — Funciones de autenticación contra el backend Laravel Sanctum.
 *
 * Todos los métodos retornan la data o lanzan el error para que el componente lo maneje.
 */
import api from './api';

const authService = {
  /**
   * Inicia sesión con email y contraseña.
   * @returns {{ token: string, user: object }}
   */
  async login(email, password, recaptchaToken) {
    const { data } = await api.post('/auth/login', { email, password }, {
      headers: { 'X-Recaptcha-Token': recaptchaToken }
    });
    return data;
  },

  /**
   * Cierra la sesión del usuario actual (revoca el token en el servidor).
   */
  async logout() {
    await api.post('/auth/logout');
  },

  /**
   * Obtiene los datos del usuario autenticado actualmente.
   * @returns {object} user
   */
  async me() {
    const { data } = await api.get('/auth/me');
    return data;
  },

  /**
   * Envía un enlace de recuperación de contraseña al correo.
   * @param {string} email
   * @param {string} recaptchaToken
   */
  async forgotPassword(email, recaptchaToken) {
    const { data } = await api.post('/auth/forgot-password', { email }, {
      headers: { 'X-Recaptcha-Token': recaptchaToken }
    });
    return data;
  },

  /**
   * Restablece la contraseña usando el token del correo.
   * @param {object} payload { email, password, password_confirmation, token }
   */
  async resetPassword(payload) {
    const { data } = await api.post('/auth/reset-password', payload);
    return data;
  },
};

export default authService;
